import { gql } from 'graphql-tag';
import { backgroundFragment } from '../background/queries';

export const generateAIImageMutation = gql`
  mutation generateAIImage(
    $imageType: BedrockImageTypesType!
    $prompt: String!
    $size: BedrockImageSizesType!
    $amount: Int
    $communityId: Int!
  ) {
    create_bedrock_image(
      image_type: $imageType
      prompt: $prompt
      size: $size
      amount: $amount
      community_id: $communityId
    ) {
      id
      urls
    }
  }
`;

export const saveAIBackgroundMutation = gql`
  mutation saveAIBackground($urls: [String]!, $id: Int!) {
    select_ai_generated_backgrounds(urls: $urls, generated_urls_id: $id) {
      ...backgroundDetail
    }
  }
  ${backgroundFragment}
`;

export const saveAIClipartMutation = gql`
  mutation saveAIClipart($urls: [String]!, $id: Int!) {
    select_ai_generated_clipart(urls: $urls, generated_urls_id: $id) {
      id
      name
      category
      thumbnail
      large_url
    }
  }
`;
